import React, { useLayoutEffect, useState } from 'react';
import {
    Box,
    Flex,
    FlexProps,
    Grid,
    Text,
} from '@chakra-ui/react';
import {
    Button,
    Counter,
    Icon,
    IconsNames,
    Image,
    RichText,
    useAppDispath,
} from 'shared';
import { useParams } from 'react-router-dom';
import { LeadSmallSection, useCart } from 'features';
import { MenuItem, Select } from '@mui/material';
// eslint-disable-next-line no-restricted-imports
import { Carousel } from 'shared/ui/Carousel';
// eslint-disable-next-line no-restricted-imports
import { Modal } from 'shared/ui/Modal';
import { Helmet } from 'react-helmet-async';
// eslint-disable-next-line no-restricted-imports
import { richTextToString } from 'shared/lib/richtext-to-string';
import { OutdoorBarArticlePageActions, useOutdoorBarArticlePageState } from '../../store';
import { OutdoorBarArticlePageMainHeader } from './OutdoorBarArticlePageMainHeader';
import { OutdoorBarArticlePageMainPortionPicker } from './OutdoorBarArticlePageMainPortionPicker';
import { OutdoorBarArticlePageMainSetsPicker } from './OutdoorBarArticlePageMainSetsPicker';
import { OutdoorBarArticlePageMainIncludedServicesSection } from './OutdoorBarArticlePageMainIncludedServicesSection';
import { OutdoorBarArticlePageMainNonIncludedServicesSection } from './OutdoorBarArticlePageMainNonIncludedServicesSection';
import { OutdoorBarArticlePageMainRecommendationsSection } from './OutdoorBarArticlePageMainRecommendationsSection';

export type OutdoorBarArticlePageMainProps = FlexProps & React.RefAttributes<HTMLDivElement>

export const OutdoorBarArticlePageMain = (props: OutdoorBarArticlePageMainProps) => {
    const { id } = useParams();
    const dispatch = useAppDispath();
    const { outdoorBarArticle, leadFormPdf } = useOutdoorBarArticlePageState();
    const { setItem, getItemCount } = useCart();

    const [portionIndex, setPortionIndex] = useState<number>(0);
    const [count, setCount] = useState(1);
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    useLayoutEffect(() => {
        if (id) {
            dispatch(OutdoorBarArticlePageActions.getOutdoorBarArticleByUid({
                uid: id,
            }));
        }
    }, [id]);
    return (
        <Flex
            {...props}
            flexDirection="column"
        >
            <Helmet>
                <title>{outdoorBarArticle?.name}</title>
                <meta name="description" content={richTextToString(outdoorBarArticle?.description)} />
                <meta property="og:title" content={outdoorBarArticle?.name} />
            </Helmet>
            <OutdoorBarArticlePageMainHeader
                title={outdoorBarArticle?.name || ''}
                padding="2rem"
                maxWidth={{
                    base: '425px',
                    lg: '1280px',
                }}
                width="100%"
                margin="0 auto"
                background="white"
            />
            <Carousel
                padding="0 2rem"
                maxWidth={{
                    base: '425px',
                    lg: '1280px',
                }}
                width="100%"
                margin="0 auto"
                background="white"
                withDialog
                items={outdoorBarArticle?.images?.map(({ url }) => <Image aspectRatio="2 / 1" width="100%" objectFit="cover" src={url} />) || []}
            />
            <Grid
                templateColumns={{
                    base: '1fr',
                    lg: '2fr 3fr',
                }}
                background="white"
                gap="2rem"
                padding="2rem"
                maxWidth={{
                    base: '425px',
                    lg: '1280px',
                }}
                width="100%"
                margin="0 auto"
            >
                <Grid templateRows="1fr auto" gap="2rem">
                    <RichText
                        fontSize="1rem"
                        content={outdoorBarArticle?.description}
                    />
                    <Button
                        onClick={handleOpen}
                        background="#000000"
                        padding="1rem"
                        cursor="pointer"
                        height="100%"
                    >
                        <Grid templateColumns="auto 1fr" gap="1rem">
                            <Box margin="auto">
                                <Icon
                                    height="1rem"
                                    width="1rem"
                                    color="white"
                                    iconName={IconsNames.Plus}
                                />
                            </Box>
                            <Text fontWeight="bold" margin="auto 0">
                                добавить
                            </Text>
                        </Grid>
                    </Button>
                </Grid>
                <OutdoorBarArticlePageMainPortionPicker
                    height="fit-content"
                    outdoorBarArticlePortions={outdoorBarArticle?.portions || []}
                />
            </Grid>
            {outdoorBarArticle?.sets && outdoorBarArticle?.sets?.length > 0 && (
                <OutdoorBarArticlePageMainSetsPicker
                    outdoorBarArticleSets={outdoorBarArticle?.sets || []}
                    padding="0 2rem"
                    maxWidth={{
                        base: '425px',
                        lg: '1280px',
                    }}
                    background="white"
                    width="100%"
                    margin="0 auto"
                />
            )}
            <OutdoorBarArticlePageMainIncludedServicesSection
                outdoorBarArticleIncludedServices={outdoorBarArticle?.includedServices || []}
                padding="2rem"
                maxWidth={{
                    base: '425px',
                    lg: '1280px',
                }}
                background="white"
                width="100%"
                margin="0 auto"
            />
            <OutdoorBarArticlePageMainNonIncludedServicesSection
                outdoorBarArticleNonIncludedServices={outdoorBarArticle?.nonIncludedServices || []}
                padding="0 2rem 2rem 2rem"
                maxWidth={{
                    base: '425px',
                    lg: '1280px',
                }}
                background="white"
                width="100%"
                margin="0 auto"
            />
            <Grid
                background="#000000"
            >
                <LeadSmallSection
                    title="НЕ МОЖЕТЕ ОПРЕДЕЛИТЬСЯ?"
                    padding="2rem"
                    buttonText="Заказать звонок"
                    background="#000000"
                    maxWidth={{
                        base: '425px',
                        lg: '1280px',
                    }}
                    width="100%"
                    margin="0 auto"
                    pdfUrl={leadFormPdf?.url}
                />
            </Grid>
            {
                outdoorBarArticle?.recommendations
                && outdoorBarArticle?.recommendations.length > 0 && (
                    <OutdoorBarArticlePageMainRecommendationsSection
                        outdoorBarArticleRecommendations={outdoorBarArticle?.recommendations || []}
                        padding="2rem"
                        maxWidth={{
                            base: '425px',
                            lg: '1280px',
                        }}
                        background="white"
                        width="100%"
                        margin="0 auto"
                    />
                )
            }
            <Modal
                open={open}
                onChange={setOpen}
                title="Выберите конфигурацию"
            >
                <Grid
                    position="relative"
                    cursor="pointer"
                >
                    <Grid
                        zIndex={50}
                        background="white"
                        gap="2rem"
                    >
                        <Grid gap="0.5rem">
                            <Text
                                fontSize="1rem"
                            >
                                Порция:
                            </Text>
                            <Grid templateColumns="1fr auto" gap="1rem">
                                <Select
                                    value={portionIndex}
                                    onChange={(e) => setPortionIndex(+e.target.value)}
                                    sx={{
                                        border: '1px solid black',
                                        borderRadius: 0,
                                        outline: 'none',
                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                            borderWidth: 0,
                                        },
                                        // Ensure no box shadow is applied on focus
                                        boxShadow: 'none',
                                        // You might also need to target the default state border
                                        '.MuiOutlinedInput-notchedOutline': {
                                            borderStyle: 'none', // Removes default border
                                        },
                                        ':focus-visible': {
                                            border: '1px solid black',
                                            borderRadius: 0,
                                            outline: 'none',
                                            boxShadow: 'none',
                                        },
                                    }}
                                >
                                    {outdoorBarArticle?.portions?.map(({
                                        value,
                                        price,
                                        currency,
                                        meassure,
                                    }, i) => (
                                        <MenuItem value={String(i)}>
                                            {value}
                                            {' '}
                                            {meassure}
                                            {' '}
                                            -
                                            {' '}
                                            {price}
                                            {currency?.abbreviation}
                                        </MenuItem>
                                    ))}
                                </Select>
                                <Counter
                                    value={count}
                                    onValueChange={(v) => (v > 0 ? setCount(v) : undefined)}
                                />
                            </Grid>
                        </Grid>
                        <Grid
                            templateColumns="1fr 2fr"
                            gap="1rem"
                        >
                            <Button
                                fontWeight="bold"
                                onClick={handleClose}
                            >
                                Закрыть
                            </Button>
                            <Button
                                background="#E74C3C"
                                fontWeight="bold"
                                onClick={() => {
                                    if (id) {
                                        const oldCount = getItemCount(
                                            'outdoor-bars',
                                            id,
                                            portionIndex,
                                        );
                                        setItem(
                                            'outdoor-bars',
                                            id,
                                            oldCount + count,
                                            portionIndex,
                                        );
                                        setCount(1);
                                        setPortionIndex(0);
                                        handleClose();
                                    }
                                }}
                            >
                                Подтвердить
                            </Button>
                        </Grid>
                    </Grid>
                    <Box
                        position="absolute"
                        height="100%"
                        width="100%"
                        zIndex={49}
                        onClick={handleClose}
                    />
                </Grid>
            </Modal>
        </Flex>
    );
};
